// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.timeline-event__tooltip .sk-tooltip__text {\n  width: auto;\n}\n", ""]);
// Exports
module.exports = exports;
